import consoleLogger from '../../../../modules/console-logger'
import slcGetTargets from '../slc-get-targets'

const [consoleLog] = consoleLogger('AdsLog')
const slcOnLoad = ({ id, enableTargets = false }) => {
  consoleLog('SLC', 'loaded', 'SLC')
  const userString = window.localStorage.getItem('user')
  let userMail = null
  if (userString) {
    userMail = JSON.parse(userString).email
  }
  window.createSessionIDAndHashedMail({ email: userMail })
  SLC('ui', window.localStorage.getItem('sessionId'))
  const hashedEmail = window.localStorage.getItem('sessionHashedMail')
  consoleLog('SLC uie:', hashedEmail, 'SLC')
  SLC('uie', hashedEmail || '')

  // Setup *AFTER* any params and data to SLC
  SLC('setup', id)

  if (enableTargets) {
    slcGetTargets()
  }
}

export default slcOnLoad
